import { IconButton } from '@eventbrite/eds-icon-button';
import { ChevronDown } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import { Button } from '@eventbrite/marmalade';
import { $FixMe } from '@eventbrite/ts-utils';
import React from 'react';
import { AnimatedDrawer } from '../AnimatedDrawer';
import FilterPanel from './FilterPanel';
import { MobileFilterPanelProps } from './types';

interface MobileFilterPanelHeaderProps {
    onClick: Function;
}

const MobileFilterHeader: React.FunctionComponent<
    MobileFilterPanelHeaderProps
> = (props) => {
    return (
        <div
            style={{
                position: 'sticky',
                minHeight: '42px',
                backgroundColor: 'white',
                display: 'flex',
                zIndex: 1000,
                top: '0px',
                padding: '8px 0px 4px 0px',
                flexDirection: 'column',
            }}
            className="marmalade-filter-panel-mobile-header"
            data-testid="mobile-filter-overlay-header"
        >
            <div
                style={{
                    justifyContent: 'space-between',
                    flexDirection: 'row',
                    alignItems: 'center',
                    display: 'flex',
                }}
            >
                <span className="eds-text-hs">{gettext('Filters')}</span>
                <IconButton
                    onClick={props.onClick}
                    iconType={<ChevronDown />}
                    title={gettext('Close filter overlay')}
                    data-testid="mobile-filter-overlay-header--close"
                />
            </div>
            {props.children}
        </div>
    );
};

interface MobileFilterFooterProps {
    onClick: () => void;
}

const MobileFilterFooter: React.FunctionComponent<MobileFilterFooterProps> = (
    props,
) => {
    const [render, setRender] = React.useState(false);

    //Delay the rendering to let the filter panel animation
    //conclude before rendering
    React.useEffect(() => {
        setTimeout(() => {
            setRender(true);
        }, 200);
    }, []);

    if (!render) {
        return null;
    }

    return (
        <section
            style={{
                position: 'fixed',
                padding: '16px',
                left: 0,
                right: 0,
                bottom: 0,
                background: 'white',
            }}
            data-testid="mobile-filter-overlay-footer"
        >
            <Button
                onClick={props.onClick}
                variant="primary"
                style={{ width: '100%' }}
            >
                {gettext('View event results')}
            </Button>
        </section>
    );
};

export const FilterPanelMobile: React.FunctionComponent<
    MobileFilterPanelProps
> = (props) => {
    const applyFilter = (...args: $FixMe) => {
        props.onFilterChange?.(...args);
    };

    return (
        <AnimatedDrawer>
            <section
                data-testid="filter-panel-mobile-container"
                style={{
                    zIndex: 1000,
                    position: 'relative',
                    display: 'block',
                    backgroundColor: 'white',
                    paddingBottom: '60px',
                }}
            >
                <FilterPanel
                    {...props}
                    isMobile={true}
                    onFilterChange={applyFilter}
                    header={
                        <MobileFilterHeader
                            key="filter-panel-mobile-filter-header"
                            onClick={() =>
                                props?.openCloseAnimatedDrawer?.(false)
                            }
                        >
                            {props.headerChildren}
                        </MobileFilterHeader>
                    }
                    footer={
                        <MobileFilterFooter
                            onClick={() =>
                                props.openCloseAnimatedDrawer?.(false)
                            }
                        />
                    }
                />
            </section>
        </AnimatedDrawer>
    );
};
export default FilterPanelMobile;
